import Global from "@/components/Global";
import { webTypeApiUrl } from "@/constants/webTypeApiUrl";


export const SaleBusinessCardHandler = {
  MyFunction: function (param) {
    alert(param);
  },
  SaveBusinessCard: function (businesscard, staffId) {
    if (businesscard.Version == null) {      
      businesscard.Version = "0"
    }
    if (businesscard.SelfIntroduction == null) {      
      businesscard.SelfIntroduction = ""
    }
    if (businesscard.CompanyPhone == null) {      
      businesscard.CompanyPhone = ""
    }
    if (businesscard.CompanyFax == null) {      
      businesscard.CompanyFax = ""
    }   
    
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/StaffBusinessCard/SaveBusinessCard",
      type: "post",
      async: false,
      data: {
        businessCard: businesscard,
        staffId: staffId
      },
      dataType: "json",
      success: function (data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        } else {
          //alert('儲存成功')
        }
      },
      error: function (a, b, c) {
      }
    });
  },
  PreviewBusinessCard: function (businesscard, staffId) {
    var previewurl = "";

    if (businesscard.Version == null) {      
      businesscard.Version = "0"
    }
    if (businesscard.SelfIntroduction == null) {      
      businesscard.SelfIntroduction = ""
    }
    if (businesscard.CompanyPhone == null) {      
      businesscard.CompanyPhone = ""
    }
    if (businesscard.CompanyFax == null) {      
      businesscard.CompanyFax = ""
    }   
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/StaffBusinessCard/PreviewBusinessCard",
      type: "post",
      async: false,
      data: {
        businessCard: businesscard,
        staffId: staffId
      },
      dataType: "json",
      success: function (data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        } else {
          previewurl = data.Result;
        }
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return previewurl;
  },
  GetBusinessCard: function (staffId) {
    var _businesscard = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/StaffBusinessCard/GetBusinessCard",
      type: "get",
      async: false,
      data: {
        staffId: staffId
      },
      dataType: "json",
      success: function (data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        } else {
          _businesscard = data.Result;
        }
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return _businesscard;
  },
  GetSalesBussinessCard: function () {
    var _businesscard = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/GetSalesBussinessCard",
      type: "get",
      async: false,
      data: {

        staffId: Global.current_staffid
      },
      dataType: "json",
      success: function (data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        } else {
          _businesscard = data.Result;
        }
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return _businesscard;
  },
  SendMediaMessage: function (businesscard) {
    //發送訊息
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/SendMediaMessage",
      type: "post",
      async: false,
      data: {
        roomId: Global.current_roomid,
        staffId: Global.current_staffid,
        filepath: businesscard.absoluteUrl,
        previewImageUrl: businesscard.previewImageUrl,
        messageType: 4
      },
      dataType: "json",
      success: function (data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        }
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
  },
  SendShareStaffBusinessCardFlexMessage: function () {
    //發送訊息
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Contract/SendShareStaffBusinessCardFlexMessage",
      type: "post",
      async: false,
      data: {
        chatRoomId: Global.current_roomid,
        staffId: Global.current_staffid
      },
      dataType: "json",
      success: function (data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        }
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/handler/SaleBusinessCardHandler.js